<template>
  <div class="sidebar">
    <el-scrollbar>
        <el-menu background-color="#333744" text-color="#fff" active-text-color="#409eff">
          <el-sub-menu index="1">
            <template #title>
              <el-icon><User /></el-icon>用户管理
            </template>
            <el-menu-item index="1-1" @click="toView('/users')">用户管理</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="2">
            <template #title>
              <el-icon><Notebook /></el-icon>产品管理
            </template>
            <el-menu-item index="2-1" @click="toView('/products')">产品管理</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="3">
            <template #title>
              <el-icon><Cellphone /></el-icon>设备管理
            </template>
            <el-menu-item index="3-1"  @click="toView('/devices')">设备管理</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="4">
            <template #title>
              <el-icon><PieChart /></el-icon>OTA升级
            </template>
            <el-menu-item index="4-1" @click="toView('/ota_update')">OTA升级</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="5">
            <template #title>
              <el-icon><Setting /></el-icon>系统管理
            </template>
              <el-menu-item index="5-1" @click="toView('/login_log')">登录日志</el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-scrollbar>
  </div>
</template>

<script>
import { Cellphone, User, Notebook, Setting, PieChart } from '@element-plus/icons-vue'

export default {
  name: 'SideBar',
  components: {
    Notebook,
    Cellphone,
    User,
    Setting,
    PieChart
  },
  props: {
    msg: String
  },
  mounted () {
    // const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
  methods: {
    toView (path) {
      this.$router.push(path)
      console.log(path)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sidebar {
  min-width: 200px;
  max-width: 200px;
  height: 100%;
  background-color: #3F4644;
}

.el-menu .el-menu-item.is-active {
    background-color: #14A97C !important;
    color: white;
    /* border-right: 3px solid var(--primary-dark, #FBA429); */
}

.el-menu .el-menu-item {
    background-color: #3F4644 !important;
    color: #FFFFFF;
}

</style>
